import axios from 'axios';

const getAprovacoes = params => axios.get('/aprovacoes-compras', {
  params,
});

const getAprovacoesList = params => axios.get('/aprovacoes-compras/list', {
  params,
});

const get = id => axios.get(`/aprovacoes-compras/${id}`);

const aprovar = id => axios.put(`/aprovacoes-compras/${id}/aprovar`, {});

const recusar = (id, data) => axios.put(`/aprovacoes-compras/${id}/recusar`, data);

const getLinks = id => axios.get(`/aprovacoes-compras/${id}/links`);

export default {
  get,
  getAprovacoes,
  getAprovacoesList,
  aprovar,
  recusar,
  getLinks,
};
